<template>
    <div v-click-outside.stop="onClickOutside">
        <div class="header_top_r_noti_b">
            <div class="header_top_r_noti" @click="showNotification" title="Thông báo">
                <i class="fas fa-bell"></i>
            </div>
            <div v-if="!this.iconNotification && this.count >0" class="header_top_r_noti_num">{{ count }}</div>
            <div class="header_top_r_noti_b_build" v-if="this.notificationShow == true">
                <ul class="header_top_r_noti_b_build_row">
                    <a href="javascipt:void(0)" v-for="(item, index) in notification" :key="index">
                        <li :style="item.watched == 0 ? 'backgroundColor: #e7ecf3' : ''"   v-html="item.message" @click="checkWatched(item.id, index)"></li>
                    </a>
                    <infinite-loading @distance="200" spinner="bubbles" @infinite="infiniteHandler"></infinite-loading>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import InfiniteLoading from 'vue-infinite-loading';
export default {
    conponents:{InfiniteLoading},
    data() {
        return{
            notification: [],
            page:2,
            isInit: true,
            intervar:null,
            notificationShow:false,
            iconNotification:false,
            count: 0
        }
    },
    created() {
        this.fetchNotification()
        .then(response => {
            var _that = this;
            if(response.data.status == 200) {
                if(response.data.data.data.length > 0) {
                    _that.notification = response.data.data.data;
                } else {}
            }
        })
        .catch(e => console.log(e));
        this.getCountNotification();
    },

    mounted() {

        // var interval_id;
        var _that = this;
        $(window).focus(function() {
            if (!this.intervar)
                this.intervar = setInterval(() => {
                _that.iconNotification = false;
                _that.isInit= true;
                _that.getCountNotification();
                // Chỉ được gọi thằng số 30s 1 lần
                // _that.fetchNotification()
                // .then(response => {
                //     if(response.data.status == 200) {
                //         if(response.data.data.data.length > 0) {
                //             _that.notification = response.data.data.data;
                //             _that.page = 2;
                //             _that.isInit = false;
                //         } else {}
                //     }
                // })
                // .catch(e => console.log(e));
                _that.isInit = false;
            }, 300000);
        });

        $(window).blur(function() {
            clearInterval(this.intervar);
            this.intervar = 0;
        });



    },
    computed: {},
    watch: {},
    methods: {
        onClickOutside(event) {
             this.notificationShow = false;
        },
        checkWatched(id, index) {
                let url = '/update-watch-notification/'+ id
                axios({
                    method: 'post',
                    url: url,
                    config: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {})
                .catch(error => {})
        },
        getCountNotification () {
            axios.get('/get-count-notification')
            .then(response => {
                this.count = response.data.data.count;
            })
            .catch(error => {

            })
        },
        showNotification() {
            this.notificationShow = !this.notificationShow;
            this.iconNotification = true;
            //Thay vì gọi 30s 1 lần thì ấn show chuông sẽ gọi lại
            this.isInit= true;
            this.fetchNotification()
            .then(response => {
                if(response.data.status == 200) {
                    if(response.data.data.data.length > 0) {
                        this.notification = response.data.data.data;
                        this.page = 2;
                        this.isInit = false;
                    } else {}
                }
            })
            .catch(e => console.log(e));

            this.isInit = false;
            axios.get('/update-notification')
            .then(response => {})
            .catch(error => {})
        },
        fetchNotification() {
            var url = this.isInit
                    ? axios.get('/get-notification')
                    : axios.get('/get-notification?page='+this.page);
            return url;
        },
        infiniteHandler($state) {
          var _that = this;
          setTimeout(function () {
            this.fetchNotification()
                .then(response => {
                    if(response.data.status == 200) {
                        if (response.data.data.data.length > 0) {
                            response.data.data.data.forEach((v,k) => {
                                _that.notification.push(v);
                            });
                            _that.page += 1;
                            $state.loaded();
                        } else {
                            $('.infinite-status-prompt').text('Không còn dữ liệu');
                            $state.complete();
                        }
                        } else {
                            $('.infinite-status-prompt').text('Không còn dữ liệu');
                            $state.complete();
                        };

                    })
                    .catch(e => console.log(e));
            }.bind(this), 1000);
        },
    },
    beforeDestroy(){
        clearInterval(this.interval);
    }
}
</script>